"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactDom = require("react-dom");
var _Icon = _interopRequireDefault(require("./Icon"));
var _functions = require("./@functions");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var FloatingMenu = function FloatingMenu(_ref) {
  var top = _ref.top,
    left = _ref.left,
    right = _ref.right,
    bottom = _ref.bottom,
    items = _ref.items,
    visible = _ref.visible,
    onClick = _ref.onClick,
    setVisible = _ref.setVisible,
    className = _ref.className;
  var reference = (0, _react.useRef)(null);
  var calculate = function calculate() {
    // if (visible) {
    var bodyHeight = document.body.offsetHeight;
    var bodyWidth = document.body.offsetWidth;
    var t = top,
      l = left,
      r = 'auto',
      b = 'auto';
    var height = reference.current.offsetHeight > items.length * 40 ? reference.current.offsetHeight : items.length * 40;
    if (top + height > bodyHeight) {
      t = 'auto';
      b = 10;
    }
    if (left + reference.current.offsetWidth > bodyWidth) {
      l = 'auto';
      r = 10;
    }
    if (left < 0) {
      l = 10;
    }
    // setCustomTop(t);
    // setCustomLeft(l);
    // setCustomRight(r);
    // setCustomBottom(b);
    reference.current.style.top = !isNaN(t) ? t + 'px' : t;
    reference.current.style.left = !isNaN(l) ? l + 'px' : l;
    reference.current.style.right = !isNaN(r) ? r + 'px' : r;
    reference.current.style.bottom = !isNaN(b) ? b + 'px' : b;
    //(t, l, r, b)
  };

  (0, _react.useEffect)(function () {
    calculate();
    if (visible) {
      setTimeout(function () {
        _functions.bodyEvents.once.mousedown(function (e) {
          if (setVisible) setVisible(false);
        });
      }, 200);
    }
  }, [visible, top, left, right, bottom, items]);
  return (0, _reactDom.createPortal)( /*#__PURE__*/_react["default"].createElement("div", {
    className: "zero-floating-menu ".concat(visible ? 'visible' : '')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    ref: reference,
    className: "content ".concat(className)
    // style={{
    // 	top: customTop,
    // 	left: customLeft,
    // 	right: customRight,
    // 	bottom: customBottom,
    // }}
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "items"
  }, items.map(function (item, i) {
    if (item.hidden) return;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "item ".concat(item.id),
      onContextMenuCapture: function onContextMenuCapture(e) {
        e.preventDefault();
        e.stopPropagation();
      },
      onMouseDownCapture: function onMouseDownCapture(e) {
        if (e.button !== 0) return;
        e.preventDefault();
        e.stopPropagation();
        item.onClick(e);
        if (!item.preventHiding && setVisible) {
          setVisible(false);
        }
      }
    }, !!item.leftIcon && /*#__PURE__*/_react["default"].createElement("div", {
      className: "icon left-icon",
      onClick: function onClick(e) {
        e.preventDefault();
        e.stopPropagation();
        item.leftIconClick(e);
      }
    }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      icon: item.leftIcon
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "name"
    }, item.name), !!item.rightIcon && /*#__PURE__*/_react["default"].createElement("div", {
      className: "icon right-icon",
      onClick: function onClick(e) {
        e.preventDefault();
        e.stopPropagation();
        item.rightIconClick(e);
      }
    }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      icon: item.rightIcon
    })));
  })))), document.body);
};
var _default = FloatingMenu;
exports["default"] = _default;